import { ReactNode } from "react";
import { useUserContext } from "../../../../contexts/UserContext";
import { SETUP_RENDERERS } from "./setupRenderers";

interface SetupRendererProps {
  children: ReactNode;
}

const SetupRenderer = ({ children }: SetupRendererProps): JSX.Element => {
  const { selected } = useUserContext();

  const Renderer = SETUP_RENDERERS[selected.setup.value];

  if (!Renderer) {
    return <>{children}</>;
  }

  return <Renderer />;
};

export default SetupRenderer;
